import { call, put, select } from 'redux-saga/effects'
import { getData as apiGetData } from 'api/Api'
import {
  addArray as addUsersArray
} from 'store/redux/users'
import {
  refresh as refreshUsers,
  setLoadStatus,
  setCursor,
  addArray as addUsersToView
} from '../redux/users'

export default function * fetchUsers (action) {
  const { refresh, limit = 20 } = action.payload

  const batchedActions = []

  if (refresh) {
    batchedActions.push(refreshUsers())
  }

  batchedActions.push(setLoadStatus({
    loading: true,
    loaded: false
  }))

  yield put(batchedActions)

  const state = yield select()

  const mode = state['view-home'].users.mode
  const keyword = state['view-home'].users.keyword
  const cursor = state['view-home'].users.cursor

  const args = {
    limit
  }
  if (mode === 'active') {
    args.active = true
  } else if (mode === 'inactive') {
    args.active = false
  }

  if (keyword) args.keyword = keyword
  if (cursor) args.cursor = cursor

  try {
    const { Users, Cursor } = yield call(apiGetData, 'UsersWithPermissions', args)

    const users = []
    const viewUsers = []

    Users.forEach(User => {
      users.push({
        id: User.Id,
        name: User.Name,
        email: User.Email,
        profileKey: User.ProfileKey,
        licenseType: User.LicenseType,
        isActive: User.Active,
        isLoaded: true,
        isLoading: false
      })

      viewUsers.push({
        id: User.Id,
        permissionLevel: User.PermissionLevel
      })
    })

    const batchedActions = [
      addUsersArray(users),
      addUsersToView(viewUsers),
      setLoadStatus({
        loading: false,
        loaded: !Cursor
      }),
      setCursor(Cursor)
    ]

    yield put(batchedActions)
  } catch (error) {
    yield put(setLoadStatus({
      loading: false,
      loaded: false
    }))
  }
}
